import { Localized } from '../../../utilities/localizedStrings';

/**
 * Renders a page not found message
 * @returns - a div element with a page not found message
 */
export const PageNotFound = () => {
    return (
        <div className="cw-PageNotFound">
            <h1>{ Localized.get('pageNotFound-heading') }</h1>
            <p>{ Localized.get('pageNotFound-message') }</p>
        </div>
    );
}
